<template>
   <div class="page-padding">
        <ProgramsHeader />
        <ProgramsDashboard :is-mockup="false"/>
   </div>
</template>
<script setup lang="ts">
import ProgramsDashboard from '@/components/ProgramsDashboard.vue';
import ProgramsHeader from '@/components/ProgramsHeader.vue';
</script>